import React, { Component } from "react";
import AthOnboardingMultipleBubble from "./AthOnboardingMultipleBubble";
import "./AthOnboardingMultiple.css";

import * as util from "../../../utils/util";
import {
  answerBubbleStyle,
  answerBubbleStyleMobile
} from "../../../utils/styles";
import { MultComponentButton } from "../../../views/onboarding/OnboardingStyles";

class AthOnboardingMultiple extends Component {
  constructor(props) {
    super(props);

    this.options = [];
    this.optionIndices = [];
    this.optionStr = "";

    this.state = {
      finished: false,
      selectedOptions: [],
      isMaxSelectNumber:false,
    };
  }

  componentDidUpdate() {
    const touchsupport = util.isMobile(navigator.userAgent);
    const doneButton = document.querySelector(
      ".multiselect-component__image-wrapper-btn"
    );
    if (doneButton && !touchsupport) doneButton.scrollIntoView();
  }

  handleSelected = option => {
    let selectedOptions = this.state.selectedOptions;
    
    const ind = selectedOptions.indexOf(option);
    if (ind > -1) {
      selectedOptions.splice(ind, 1);
    } else {
      selectedOptions.push(option);
    }
    this.setState({ selectedOptions: selectedOptions });

    if(selectedOptions.length == this.props.maxSelectSize){
      this.setState({
        isMaxSelectNumber : true
      })
    }else{
      this.setState({
        isMaxSelectNumber : false
      })
    }

  };

  handleDone = () => {
    if (this.state.selectedOptions.length > 0) {
      this.setState({ finished: true });
      this.options = this.state.selectedOptions.map(option => option.label);
      this.optionIndices = this.state.selectedOptions.map(option => option.key);
      this.optionStr = this.options.join(", ");
      this.props.triggerNextStep({
        value: this.optionIndices.join(", ") + ":" + this.optionStr
      });
    }
  };

  renderOptions = () => {
    let renderData = this.props.data.map(option => {
      return (
        <AthOnboardingMultipleBubble
          option={option}
          key={"concern-bubble-" + option.key}
          label={option.label}
          handleSelected={this.handleSelected}
          selectedOptions={this.state.selectedOptions}
          isMaxSelectNumber ={this.state.isMaxSelectNumber}
        />
      );
    });

    return (
      <div className="ath-onboarding-multiple">
        <ul className=" rsc-os-options">{renderData}</ul>
        <div
          className={
            this.state.selectedOptions.length > 0
              ? "ath-onboarding-multiple__done-button multiselect-component__selectable"
              : "hide-me"
          }
          onClick={this.handleDone}
        >
          <div className="multiselect-component__label">
            <MultComponentButton className="multiselect-component__image-wrapper-btn">
              Done
            </MultComponentButton>
            <div className="multiselect-component__text">
              <div className="multiselect-component__title" />
            </div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    if (this.state.finished) {
      return (
        <div
          style={
            this.props.answerWidthCheck <= 812
              ? answerBubbleStyleMobile
              : answerBubbleStyle
          }
        >
          {this.optionStr}
        </div>
      );
    } else {
      return (
        <div
          style={{ margin: "1px auto", width: "100%" }}
          className={this.state.finished ? "rsc-ts sc-dnqmqq" : null}
        >
          {this.renderOptions()}
        </div>
      );
    }
  }
}

export default AthOnboardingMultiple;



// WEBPACK FOOTER //
// ./src/ath/components/onboarding/AthOnboardingMultiple.js